docReady(function()
{
    const header = document.querySelector(".header-wander");
    if(!header){ return; }
    const whitebg = header.offsetHeight;

    window.addEventListener("scroll",function () 
    {
        stickyHeader()
    });

    function stickyHeader() 
    {
        if (window.scrollY > whitebg) 
        {
            header.classList.add("header-wander--whitebg");
        } 
        else 
        {
            header.classList.remove("header-wander--whitebg");
        }
    }    
})